export type TileEnv = "dev" | "prod";

let _env: TileEnv = "dev";

export function getEnv(): TileEnv {
    return _env;
}

export function setEnv(env: TileEnv): void {
    _env = env;
}

export function getEnvParam(): string {
    return `env=${_env}`;
}
